import { useState, useEffect } from "react";
import DashboardLineChart from "./charts/DashboardLineChart";
import "../styling/Dashboard.css";
import TableDashboard from "./tables/TableDashboard";
import RevenueInfoTile from "./tiles/RevenueInfoTile";
import RightPanel from "./panels/RightPanel";
import axios from "axios";
import GetStartedPanel from "./panels/GetStartedPanel";
import RightSidebar from "./RightSidebar";

const Dashboard = ({
  setRightSidebar,
  rightPaneEventClick,
  onPanelEventClick,
  setSelectedMenuItem,
  handleViewAllClick,
  onEventClick,
  setInitialBusinessEventTab,
}) => {
  const [event, setEvent] = useState([]);

  const [latestEvents, setLatestEvents] = useState(null);

  const [tile, setTile] = useState(null);

  const [teamMembers, setTeamMembers] = useState([]);

  // useEffect hook to fetch event details when component mounts
  useEffect(() => {
    fetchDashboardData();
    fetchDashboardTileData();
    fetchLatestEvents();
    fetchTeamMembers();
  }, []);

  // Function to fetch events from API
  const fetchDashboardData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/dashboard-data`,
        {
          withCredentials: true,
        }
      );
      setEvent(response.data.data);
    } catch (error) {
      console.log("Error fetching dashboard chart data... ", error);
    }
  };

  const fetchLatestEvents = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/events`,
        {
          withCredentials: true,
        }
      );
     
      setLatestEvents(response.data.data);

     
    } catch (error) {
      console.log(
        "Something went wrong while fetching latest events....",
        error
      );
    }
  };

  const fetchDashboardTileData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/dashboard-tile`,
        {
          withCredentials: true,
        }
      );
      setTile(response.data.data);
     
    } catch (error) {
      console.log("Error fetching dashboard tile data... ", error);
    }
  };

  const fetchTeamMembers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/business-user/teamMembers`,
        { withCredentials: true }
      );
      
      setTeamMembers(res.data.data.teamMembers);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const generateMonthYears = () => {
    const currentDate = new Date();
    const currentMonthIndex = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    // Calculate the start month index for the past 12 months
    let startMonthIndex = currentMonthIndex - 11; 
    let startYear = currentYear;
    if (startMonthIndex < 0) {
      startMonthIndex += 12; 
      startYear -= 1; 
    }

    // Create an array of month-year strings for the last 12 months
    const monthYears = [];
    for (let i = 0; i < 12; i++) {
      const monthIndex = (startMonthIndex + i) % 12; 
      const year = startYear + Math.floor((startMonthIndex + i) / 12);
      monthYears.push(`${monthIndex} ${year}`);
    }

    return monthYears;
  };
  const monthYears = generateMonthYears();

  const labels = monthYears.map((monthYear, index) => {
    const [month] = monthYear.split(" ");
    return monthNames[month];
  });
  const data = monthYears.map((monthYear) => {
    const [month, year] = monthYear.split(" ");
    const matchingEntry = event.find(
      (entry) =>
        entry._id.month - 1 === parseInt(month) &&
        entry._id.year === parseInt(year)
    );
    return matchingEntry ? matchingEntry.totalExpPaymentAmount : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "",
        data: data,
        fill: false,
        borderColor: "#260F99",
        tension: 0.2,
        font: {
          family: "Poppins",
        },
      },
    ],
  };

  const entries = [{}, "Entry 2", "Entry 3", "Entry 4"];

  const chartOptions = {
    scales: {
      x: {
        type: "category",
        position: "bottom",
      },
      y: {
        type: "linear",
        min: 0,
        max: 100,
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      title: {
        display: true,
        align: "start",
        text: "Revenue",

        color: "#000000",
        font: {
          size: 24,
          family: "Poppins",
          weight: "500",
        },
        padding: 30,
      },
    },
  };

  return (
    <div className="dashboard-with-sidebar">
        {/* MAIN COLUMN */}
        <main className="dashboard-main">
          <RevenueInfoTile tile={tile || [{}, {}, {}, {}]} />

          <div className="dashboard-card">
            <DashboardLineChart data={chartData} options={chartOptions} />
          </div>

          <div className="dashboard-card">
            <TableDashboard
              onEventClick={onEventClick}
              setInitialBusinessEventTab={setInitialBusinessEventTab}
            />
          </div>
        </main>

        {/* RIGHT SIDEBAR */}
        <RightSidebar>
          {latestEvents && latestEvents.length > 0 ? (
            <RightPanel
              latestEvent={latestEvents}
              teamMembers={teamMembers || []}
              rightPaneEventClick={rightPaneEventClick}
              onPanelEventClick={onPanelEventClick}
              setSelectedMenuItem={setSelectedMenuItem}
              handleViewAllClick={handleViewAllClick}
            />
          ) : (
            <GetStartedPanel setSelectedMenuItem={setSelectedMenuItem} />
          )}
        </RightSidebar>
      </div>
  );
};

export default Dashboard;
